import styled from 'styled-components';
import { StatusPickerOverlay } from 'components/atoms/status-picker/status-picker-overlay';
import { ActionPanel } from 'components/molecules/action-panel';

export const StatusPicker = styled(StatusPickerOverlay)`
  [role='listbox'] {
    width: 100%;
  }
`;

export const Popover = styled(ActionPanel.Popover)`
  width: 240px;

  ${StatusPicker} {
    padding: 0 !important;
    margin-bottom: var(--popover-spacing);
    border: none;
    box-shadow: none !important;

    strong {
      display: none;
    }

    .status-picker__option {
      padding-left: var(--popover-spacing);
      border-left: none;
    }
  }
`;
